import { forwardRef, HTMLProps } from 'react'
import clsx from 'classnames'
import { motion } from 'framer-motion'
import { Text } from '@/shared/ui'
import { ImgPlaceholder } from '@/shared/icons/img-placeholder'
import { variantsCards } from '@/shared/constants/variants'
import style from './analytic-card.module.scss'

interface AnalyticSkeletonCardProps extends Omit<HTMLProps<HTMLDivElement>, 'title'> {
  index?: number
}

export const AnalyticSkeletonCard = forwardRef<HTMLLIElement, AnalyticSkeletonCardProps>((props, ref) => {
  const { className, index } = props

  return (
    <motion.li
      ref={ref}
      className={clsx(style.container, className)}
      variants={variantsCards}
      custom={index}
      viewport={{ amount: 0.45, once: true }}
    >
      <div className={style.poster}>
        <ImgPlaceholder className={style.placeholder} />
      </div>
      <Text className={style.desc} type="t1" tagName="div">
        <span className="skeleton" />
        <span className="skeleton" />
        <span className="skeleton" />
      </Text>

      <footer className={style.footer}>
        <Text className={style.date} type="d" tagName="div">
          <span className="skeleton" />
        </Text>
      </footer>
    </motion.li>
  )
})

AnalyticSkeletonCard.displayName = 'AnalyticSkeletonCard'
